import { ComponentProps } from "react";
import styled from "@emotion/styled";

export type CardContainerProps = ComponentProps<"div">;

export const CardContainer = styled((props: CardContainerProps) => (
  <div {...props} />
))`
  background-color: ${({ theme }) => theme.colors.background.default};
  border-radius: ${({ theme }) => theme.roundness.md};
  border: 1px solid ${({ theme }) => theme.colors.component.border[2]};
`;
